<app-bread-crumb [items]="[{text:  'parcerias',link:'/admin/partnership'},{text:'detalhe'}]"
  [sectionTitle]="'Detalhe da Parceria'"></app-bread-crumb>

  <section class="content">

    <div class="row">

      <div class="col-md-2">

            <img
              class="img-responsive"
              style="width:120px ;height:120px ; margin:0 auto;border-radius:50%;border:1px solid #f7814a;"
              [src]="partinership?.picturePartiner || 'http://localhost:4200/assets/Khuzela.png'"
              alt="imagem do parceiro">

      </div>


      <div class="col-md-8">

        <div class="box box-widget widget-user-2" style="border-top: 2px solid #f35309;">

          <div class="box-footer no-padding">

            <ul class="nav nav-stacked">
              <li><a href="javascript:void(0);"><strong>Clube</strong> <span class="pull-right">{{partinership?.nameClub}}</span></a></li>
              <li><a href="javascript:void(0);"><strong>Parceiro</strong> <span class="pull-right">{{partinership?.namePartner}}</span></a></li>
              <li><a href="javascript:void(0);"><strong>Descrição da Parceria</strong> <span class="pull-right">{{partinership?.destription}}</span></a></li>
              <li><a href="javascript:void(0);"><strong>Parceria criada em:</strong> <span class="pull-right">{{partinership?.created_at | date:'dd/MM/yyyy HH:mm:ss'}}</span></a></li>
              <li class="botao">
                <button type="button" (click)="editPartinership(partinership)" class="btn btn-outline-danger pull-right"><strong><i
                      class="fa fa-edit"></i> Editar</strong></button>
              </li>
            </ul>

          </div>

        </div>

        <h3>Serviço</h3>

        <div class="box box-widget widget-user-2" style="border-top: 2px solid #f35309;">

          <div class="box-footer no-padding">

            <ul class="nav nav-stacked">
              <li><a href="javascript:void(0);"><strong>Serviço</strong> <span class="pull-right">{{partinership?.nameService}}</span></a></li>
              <li><a href="javascript:void(0);"><strong>Descrição: </strong> <span class="pull-right">{{partinership?.descriptionService}}</span></a></li>
              <li><a href="javascript:void(0);"><strong>Bónus Clube</strong> <span class="pull-right">{{partinership?.clubBonus}} {{partinership?.percentName}}</span></a></li>
              <li><a href="javascript:void(0);"><strong>Bónus Sócio</strong> <span class="pull-right">{{partinership?.partnerBonus}} {{partinership?.percentName}}</span></a></li>
              <li><a href="javascript:void(0);"><strong>Bónus Khuzela</strong> <span class="pull-right">{{partinership?.khuzelaBonus}} {{partinership?.percentName}}</span></a></li>
            </ul>

          </div>

        </div>

      </div>

      <div class="col-md-2">

        <img
          class="img-responsive"
          style="width:120px ;height:120px ; margin:0 auto;border-radius:50%;border:1px solid #f7814a;"
          [src]="partinership?.pictureClub || 'http://localhost:4200/assets/Khuzela.png'"
          alt="imagem do parceiro">

  </div>

    </div>

  </section>
